import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Header = () => {
  const { user, logout, userRole } = useAuth();
  const navigate = useNavigate();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showSheetLinks, setShowSheetLinks] = useState(false);

  const googleSheetLinks = [
    { label: 'GRID (Slab & Appraisal)', url: 'https://docs.google.com/spreadsheets/d/1RnPZzlmyZTAu42DI9x0VhyebWhLhzBoaTwpL-1cjfJQ/edit' },
    { label: 'ICOMM Staff Data', url: 'https://docs.google.com/spreadsheets/d/1EiQWD-_ShVNbz_cCSLqdRMjxTaNPIYz8DfL5D62Wr8s/edit' },
    { label: 'Role-wise KRAs', url: 'https://docs.google.com/spreadsheets/d/1dJEiixasR1vP1hWED4TF9Yn4I1Jyr5gYrTXGGMxFD9Y/edit' },
  ];

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const styles = {
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '16px 24px',
      backgroundColor: '#1a1a2e',
      borderBottom: '1px solid #16213e',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    },
    leftSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
    },
    logo: {
      fontSize: '22px',
      fontWeight: 'bold',
      color: '#e94560',
      letterSpacing: '1px',
    },
    logoSubtext: {
      fontSize: '12px',
      color: '#999',
      marginTop: '2px',
    },
    rightSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
    },
    userInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    userDetails: {
      textAlign: 'right',
    },
    username: {
      fontSize: '14px',
      fontWeight: '600',
      color: 'white',
    },
    roleContainer: {
      display: 'inline-block',
      padding: '4px 12px',
      borderRadius: '12px',
      fontSize: '11px',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      marginTop: '2px',
    },
    roleBadgeLeadership: {
      backgroundColor: 'rgba(233, 69, 96, 0.2)',
      color: '#e94560',
    },
    roleBadgeStandard: {
      backgroundColor: 'rgba(15, 52, 96, 0.2)',
      color: '#0f3460',
    },
    syncStatus: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      fontSize: '12px',
      color: '#8bc34a',
    },
    syncDot: {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: '#8bc34a',
      animation: 'pulse 2s infinite',
    },
    logoutBtn: {
      padding: '8px 16px',
      backgroundColor: 'rgba(233, 69, 96, 0.1)',
      color: '#e94560',
      border: '1px solid #e94560',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '13px',
      fontWeight: '600',
      transition: 'all 0.3s ease',
    },
    logoutBtnHover: {
      backgroundColor: '#e94560',
      color: 'white',
    },
    modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    modalContent: {
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '32px',
      maxWidth: '400px',
      boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
      textAlign: 'center',
    },
    modalTitle: {
      fontSize: '18px',
      fontWeight: '700',
      color: '#1a1a2e',
      marginBottom: '12px',
    },
    modalText: {
      fontSize: '14px',
      color: '#666',
      marginBottom: '24px',
    },
    modalButtons: {
      display: 'flex',
      gap: '12px',
      justifyContent: 'center',
    },
    modalBtn: {
      padding: '10px 20px',
      borderRadius: '6px',
      border: 'none',
      fontSize: '14px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    confirmBtn: {
      backgroundColor: '#e94560',
      color: 'white',
    },
    cancelBtn: {
      backgroundColor: '#f0f0f0',
      color: '#333',
    },
  };

  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
        `}
      </style>
      <header style={styles.header}>
        <div style={styles.leftSection}>
          <div>
            <div style={styles.logo}>PAS</div>
            <div style={styles.logoSubtext}>Performance Appraisal System</div>
          </div>
        </div>

        <div style={styles.rightSection}>
          <div style={{ position: 'relative' }}>
            {(userRole === 'leadership' || userRole === 'dept_admin') && (
            <>
            <button
              style={{
                display: 'flex', alignItems: 'center', gap: '6px',
                padding: '6px 14px', backgroundColor: 'rgba(139,195,74,0.15)',
                color: '#8bc34a', border: '1px solid rgba(139,195,74,0.3)',
                borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '600',
              }}
              onClick={() => setShowSheetLinks(!showSheetLinks)}
            >
              <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#8bc34a' }}></span>
              Google Sheets
              <span style={{ fontSize: '10px' }}>{showSheetLinks ? '\u25B2' : '\u25BC'}</span>
            </button>
            {showSheetLinks && (
              <div style={{
                position: 'absolute', top: '110%', right: 0, backgroundColor: '#1a1a2e',
                border: '1px solid #0f3460', borderRadius: '8px', padding: '8px 0',
                minWidth: '220px', zIndex: 100, boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
              }}>
                {googleSheetLinks.map((link, i) => (
                  <a key={i} href={link.url} target="_blank" rel="noopener noreferrer" style={{
                    display: 'block', padding: '10px 16px', color: '#bbb', textDecoration: 'none',
                    fontSize: '13px', borderBottom: i < googleSheetLinks.length - 1 ? '1px solid #0f3460' : 'none',
                  }}
                  onMouseEnter={e => { e.target.style.backgroundColor = 'rgba(233,69,96,0.1)'; e.target.style.color = '#e94560'; }}
                  onMouseLeave={e => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#bbb'; }}
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            )}
            </>
            )}
          </div>

          <div style={styles.userInfo}>
            <div style={styles.userDetails}>
              <div style={styles.username}>{user?.username || 'User'}</div>
              <div
                style={{
                  ...styles.roleContainer,
                  ...(userRole === 'leadership' || userRole === 'dept_admin'
                    ? styles.roleBadgeLeadership
                    : styles.roleBadgeStandard),
                }}
              >
                {userRole === 'leadership' ? 'Admin' : userRole === 'dept_admin' ? `Dept Admin${user?.department ? ' — ' + user.department : ''}` : 'Project Manager'}
              </div>
            </div>
          </div>

          <button
            style={styles.logoutBtn}
            onMouseEnter={(e) =>
              Object.assign(e.target.style, styles.logoutBtnHover)
            }
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'rgba(233, 69, 96, 0.1)';
              e.target.style.color = '#e94560';
            }}
            onClick={() => setShowLogoutConfirm(true)}
          >
            Logout
          </button>
        </div>
      </header>

      {showLogoutConfirm && (
        <div style={styles.modal} onClick={() => setShowLogoutConfirm(false)}>
          <div
            style={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={styles.modalTitle}>Confirm Logout</div>
            <div style={styles.modalText}>
              Are you sure you want to logout? You'll need to login again to
              access the system.
            </div>
            <div style={styles.modalButtons}>
              <button
                style={{
                  ...styles.modalBtn,
                  ...styles.cancelBtn,
                }}
                onClick={() => setShowLogoutConfirm(false)}
              >
                Cancel
              </button>
              <button
                style={{
                  ...styles.modalBtn,
                  ...styles.confirmBtn,
                }}
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
